import { AvailabilityType } from "@enums/AvailabilityType.enum";

export class ChangeAvailabilityRequest
{
    connectorId: number;
    type: AvailabilityType;
}